import { Command } from 'commands/Commands';

export class ChangeMemberYoutubeVisibility extends Command {
  type: string = 'Member.ChangeYoutubeVisibility';
  priority = 100;
}
